// Single flat plan: Fast Estimate Pro — $99.99/mo.
// Primary checkout: the user's Stripe Payment Link (REACT_APP_STRIPE_PRO_MONTHLY),
// with client_reference_id + prefilled_email so the webhook maps payment -> account.
// Fallback: dynamic backend checkout session (POST /billing/checkout).
import api from "./api";

export const PORTAL_URL = process.env.REACT_APP_STRIPE_PORTAL_URL || "";
export const PRO_PRICE = "$99.99";
const PRO_LINK = process.env.REACT_APP_STRIPE_PRO_MONTHLY || "";

export async function startCheckout(user) {
  if (PRO_LINK) {
    const params = new URLSearchParams();
    if (user?.id) params.set("client_reference_id", user.id);
    if (user?.email) params.set("prefilled_email", user.email);
    const qs = params.toString();
    window.location.assign(qs ? `${PRO_LINK}?${qs}` : PRO_LINK);
    return { url: PRO_LINK };
  }
  const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
  if (data?.url) window.location.assign(data.url);
  return data;
}
